export default __webpack_public_path__ + "static/IBMPlexSans-BoldItalic-fd8c915c3629529bafcf4f4e04fb7691.woff";